import { Position } from '@xyflow/react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router';
import { ArrowTopRightOnSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';
import InputOutputPorts from '@/components/nodes/InputOutputPorts';
import { memo } from 'react';
import { pathwayActions } from '@/stores/pathwayStore';
import { SYSTEM_TYPE_TO_LABEL } from '@/consts';
import { settingsActions } from '@/stores/settingsStore';

const SystemNode = ({ data: node }) => {
  const { id, inputs, outputs, system, mirrored } = node;
  const inputPosition = mirrored ? Position.Right : Position.Left;
  const outputPosition = mirrored ? Position.Left : Position.Right;
  const { projectId } = useParams();
  const navigate = useNavigate();
  const removeNode = e => {
    e.stopPropagation();
    pathwayActions.removeNode(node.id);
  };

  const handleNodeClick = () => {
    settingsActions.closePalette();
    navigate(`/projects/${projectId}/analysis/systems/${system.id}/`, { state: { node } });
  };

  return (
    <div
      className="group/item bg-white border border-gray-700 w-112 rounded-lg shadow-lg hover:border-gray-900"
      onClick={handleNodeClick}
    >
      <div className="flex">
        <div className="group/edit invisible group-hover/item:visible">
          <div onClick={removeNode} className="nodrag pt-2 pl-2">
            <XMarkIcon className="h-6 w-6 text-gray-400 hover:text-black" />
          </div>
        </div>
        <div className="flex-1">
          <p className="p-2 mt-4 text-xl font-semibold text-center">{system?.name}</p>
          <p className="mb-4 text-lg text-center">{SYSTEM_TYPE_TO_LABEL?.[system?.system_type]}</p>
        </div>
        <div className="flex m-2 justify-end group/edit invisible group-hover/item:visible">
          <ArrowTopRightOnSquareIcon className="w-6 h-6 text-gray-400 hover:text-black cursor-pointer" />
        </div>
      </div>
      <div>
        <div className="flex">
          <InputOutputPorts
            parentId={id}
            nodes={mirrored ? outputs : inputs}
            label={mirrored ? 'Outputs' : 'Inputs'}
            handleType={mirrored ? 'output' : 'input'}
            handlePosition={mirrored ? outputPosition : inputPosition}
          />
          <InputOutputPorts
            parentId={id}
            nodes={mirrored ? inputs : outputs}
            label={mirrored ? 'Inputs' : 'Outputs'}
            handleType={mirrored ? 'input' : 'output'}
            handlePosition={mirrored ? inputPosition : outputPosition}
          />
        </div>
      </div>
    </div>
  );
};

SystemNode.propTypes = {
  data: PropTypes.object,
};

const MemoizedSystemNode = memo(SystemNode);

export default MemoizedSystemNode;
